import React, { useState, useEffect } from 'react';

/**
 * Component that tries to load images in order
 * If first image fails, tries second, then third, etc.
 * Falls back to HI-TEC logo if all images fail
 */
const FallbackImage = ({ images, alt, className, fallbackIcon = true }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [allFailed, setAllFailed] = useState(false);
  const [imageKey, setImageKey] = useState(0);

  // Reset state when images prop changes
  useEffect(() => {
    setCurrentIndex(0);
    setAllFailed(false);
    setImageKey(prev => prev + 1);
  }, [images]);

  const handleError = () => {
    // Try next image
    if (currentIndex < images.length - 1) {
      setCurrentIndex(prev => prev + 1);
      setImageKey(prev => prev + 1);
    } else {
      // All images failed
      setAllFailed(true);
    }
  };

  // No images provided - show HI-TEC logo
  if (!images || images.length === 0 || allFailed) {
    if (fallbackIcon) {
      return (
        <div className={`flex items-center justify-center bg-gray-50 ${className}`}>
          <img 
            src="/hi-tec-logo.png" 
            alt="HI-TEC" 
            className="w-24 h-24 object-contain opacity-50"
          />
        </div>
      );
    }
    return null;
  }

  return (
    <img
      key={imageKey}
      src={images[currentIndex]}
      alt={alt}
      className={className}
      onError={handleError}
    />
  );
};

export default FallbackImage;
